module.exports = __webpack_public_path__ + "img/study_stacontent_icon4.05621e83.png";